import styled from 'styled-components';

export const StyledSvgIcon = styled.div`
    width: ${(props) => `${props.width}px`};
    display: inline-block;
`;

export const StyledIconBackground = styled.i`
    &:after {
      width: 100%;
      background-image: url('data:image/svg+xml;base64,${(props) => props.icon}');
      background-size: cover;
      height: 0;
      padding: 0; /* reset */
      padding-bottom: 100%;
      display: inline-block;
      content: '';
    }
`;
